/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const AdobeAcrobat32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none">
            <path fill="#000B1D" d="M5 0h22a5 5 0 015 5v22a5 5 0 01-5 5H5a5 5 0 01-5-5V5a5 5 0 015-5z" />
            <path
                fill="#F7F8F7"
                d="M20.012 18.73s5.4-.958 5.4.847c0 1.807-3.346 1.067-5.4-.847m-3.993.141c-1.665.4-2.493.81-2.493.81l.686-1.5c.683-1.495 1.378-3.52 1.378-3.52.944 1.71 2.812 3.732 2.812 3.732s-.731.075-2.383.478M13.874 8.108c0-1.575.515-2 .924-2 .409 0 .863.192.88 1.559.019 1.363-.88 4.037-.88 4.037-.303-.33-.924-2.028-.924-3.596M6 25.522c-1.652-.963 3.478-3.949 4.405-4.043 0-.01-2.67 5.054-4.405 4.043m20.994-5.731c-.017-.158-.161-2-3.504-1.921-3.346.079-4.154.287-4.154.287s-2.5-2.479-3.408-4.403c0 0 1.102-3.158 1.06-5.14-.045-1.983-.535-3.133-2.093-3.114-1.553.02-1.788 1.348-1.582 3.332.187 1.782 1.13 3.87 1.13 3.87s-.72 2.192-1.674 4.368c-.95 2.173-1.6 3.32-1.6 3.32s-3.22 1.054-4.618 2.326c-1.395 1.27-1.965 2.243-1.227 3.216.634.847 2.856 1.036 4.83-1.502 1.987-2.542 2.876-4.135 2.876-4.135s3.024-.81 3.958-1.033c.943-.227 2.07-.4 2.07-.4s2.76 2.711 5.43 2.617c2.647-.07 2.525-1.53 2.506-1.688"
            />
        </g>
    </AccessibleSVG>
);

export default AdobeAcrobat32;
